import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const clickNewCampaign = {
  element: '#new-campaign-btn',
  popover: {
    title: 'Getting Started!',
    description: 'To begin creating your new campaign, click on the <strong>"New Campaign"</strong> button.',
    side: 'left',
    align: 'start',
    onNextClick: () => {
      const newCampaignButton = document.querySelector('#new-campaign-btn');

      if (newCampaignButton) {
        newCampaignButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      }
    }
  }
};
